<template>
  <div class="columns is-gapless hand" @click="selData(1)">
    <div class="column is-10">
      <div>
        <span
          class="has-text-white has-text-centered numero"
          :class="active1(index)"
          >{{ numberreg }}</span
        >
        <strong :class="active(index, selcolumn.columnProducto)"
          >Producto: {{ codigoproducto }} - {{ nombreproducto }}</strong
        >
        <small
          v-if="showdescripcion"
          :class="active(index, selcolumn.columndescripcion)"
          >{{ reg.descripcion }}</small
        >
        |
        <span :class="active(index, selcolumn.columnbodega)">Bodega:</span>
        <span :class="active(index, selcolumn.columnbodega)"
          >{{ bodega }},</span
        >
        <span v-show="costo" class="tag is-rounded is-link fontMono"
          >Costo: {{ costo | number(2) }}
        </span>
        <span
          v-show="existencia"
          class="
            tag
            is-rounded
            has-background-grey-light has-text-white
            fontMono
          "
          >Existencia: {{ existencia | number(2) }}
        </span>
      </div>
      <div class="datospruducto">
        <table cellspacing="0" style="width: 100%">
          <tr>
            <td style="width: 17%">
              <div style="float: left">
                <span :class="active(index, selcolumn.columnCantidad)"
                  >Cantidad</span
                >
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span :class="active(index, selcolumn.columnCantidad)">{{
                  cantidad | number(2)
                }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 25%">
              <div style="float: left">
                <span :class="active(index, selcolumn.columnVlrunitario)"
                  >Vlr unitario:</span
                >
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span :class="active(index, selcolumn.columnVlrunitario)">{{
                  punitario | number(2)
                }}</span>
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float: left">
                <span :class="active(index, selcolumn.columnDescuento)"
                  >Dcto:</span
                >
              </div>
              <div style="float: right" class="fontMono has-text-right">
                <span :class="active(index, selcolumn.columnDescuento)"
                  >{{ descuento }}%</span
                >
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 30%">
              <div style="float: left">Sub Total:</div>
              <div style="float: right" class="fontMono has-text-right">
                {{ subtotal | number(2) }}
              </div>
            </td>
            <td style="width: 2%"></td>
            <td style="width: 10%">
              <div style="float: left">Iva:</div>
              <div style="float: right" class="fontMono has-text-right">
                {{ iva | number(2) }}%
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="column fontMono has-text-right">
      <span v-show="reg.tipo1 === '-'">-</span>
      {{ total | number(2) }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["empresa"]),
    showdescripcion() {
      const _this = this;
      let returned = false;
      for (let index in this.selection) {
        const sel = _this.selection[index];
        if (sel.cod === "descripcion") {
          returned = true;
        }
      }
      return returned;
    },
    costo() {
      if (
        this.reg.objetoProducto &&
        this.reg.objetoProducto.datosProducto &&
        this.reg.objetoProducto.datosProducto[this.reg.bodega]
      ) {
        return this.reg.objetoProducto.datosProducto[this.reg.bodega]
          .ultimoCalculo.costo;
      } else {
        return false;
      }
    },
    existencia() {
      if (
        this.reg.objetoProducto &&
        this.reg.objetoProducto.datosProducto &&
        this.reg.objetoProducto.datosProducto[this.reg.bodega]
      ) {
        if (this.empresa.lote) {
          if (
            this.reg.objetoProducto.lote &&
            this.reg.batchcodigo &&
            this.reg.objetoProducto.lote[this.reg.bodega] &&
            this.reg.objetoProducto.lote[this.reg.bodega][this.reg.batchcodigo]
          ) {
            return this.reg.objetoProducto.lote[this.reg.bodega][
              this.reg.batchcodigo
            ].existencia;
          } else {
            return 0;
          }
        } else {
          return this.reg.objetoProducto.datosProducto[this.reg.bodega]
            .existencia.unidades;
        }
      } else {
        return false;
      }
    },
    bodega() {
      if (this.reg.nombrebodega) {
        return `${this.reg.nbodega} - ${this.reg.nombrebodega}`;
      } else {
        return "No encontrada";
      }
    },
    descuento() {
      if (this.reg.descuento) {
        const desc = parseFloat(this.reg.descuento);
        if (isNaN(desc)) {
          return 0;
        } else {
          return desc;
        }
      } else {
        return 0;
      }
    },
    total() {
      return this.subtotal + (this.subtotal * this.iva) / 100;
    },
    iva() {
      if (this.reg.objetoProducto && this.reg.objetoProducto.linea) {
        return this.reg.objetoProducto.linea.vImpuesto;
      } else {
        return 0;
      }
    },
    subtotal() {
      return this.valor - (this.valor * parseFloat(this.descuento)) / 100;
    },
    numberreg() {
      if (this.reg.esTotal) {
        return "T";
      } else {
        return this.index + 1;
      }
    },
    valor() {
      return this.cantidad * this.punitario;
    },
    codigoproducto() {
      if (this.reg.nproducto) {
        return this.reg.nproducto;
      } else {
        return "xx";
      }
    },
    nombreproducto() {
      if (this.reg.nombreproducto) {
        return this.reg.nombreproducto;
      } else {
        return "Nombre del producto";
      }
    },
    cantidad() {
      if (this.reg.cantidad) {
        const cantidad = parseFloat(this.reg.cantidad);
        if (isNaN(cantidad)) {
          return 0;
        } else {
          return cantidad;
        }
      } else {
        return 0;
      }
    },
    punitario() {
      if (this.reg.vlrUnitario) {
        return this.reg.vlrUnitario;
      } else {
        return 0;
      }
    },
  },
  props: {
    index: Number,
    fila: Number,
    columna: Number,
    selection: Array,
    reg: Object,
    selcolumn: Object,
  },
  methods: {
    active(f, c) {
      if (c === this.columna && f === this.fila) {
        return {
          "is-select": true,
        };
      } else {
        if (!this.reg[this.selection[c - 1].valida]) {
          return {
            "is-error": true,
          };
        }
      }
    },
    active1(f) {
      if (f === this.fila) {
        return "has-background-primary";
      } else {
        return "has-background-grey";
      }
    },
    selData(c) {
      this.$emit("columna", c);
      this.$emit("fila", this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.numero {
  font-size: 14px;
  padding: 3px 7px 3px 7px;
  width: 27px;
  border-radius: 20px;
}
.gris {
  color: #7a7a7a;
}
.textcuenta {
  font-weight: bold;
}
.is-select {
  background-color: #3273dc;
  color: #ffffff;
}
.is-select1 {
  color: #00d1b2;
  font-size: 14px;
}
.is-error {
  color: #ff3860;
}
.datospruducto {
  table,
  td,
  th {
    font-size: 14px;
    // border: 1px solid #eeeeee !important;
    padding-left: 3px !important;
    padding-right: 3px !important;
    color: #8b8b8b !important;
  }
  tfoot {
    border: 0px !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/registrar/Viewregistrofrapvta2.vue